import React from 'react';
import Search from './components/SearchField';
import CreateBtn from './components/CreateButton';
import StatusSelect from './components/StatusSelect';
import CountOfItem from './components/CountOfItem';
import SortBy from './components/SortBy/SortBy';
import style from './ScheduleControlPanel.module.scss';

const ScheduleControlPanel: React.FC = () => {
	return (
		<div data-test="ScheduleControlPanel">
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<StatusSelect />
				</div>
				<div className={style.verticalAlignBlock}>
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</div>
	);
};

export default ScheduleControlPanel;
